import { gql } from '@/utilities/gql';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { gqlClient } from '@/utilities/graphQLClient';
import { getDateRangeByPeriod } from '@utilities/timeSeriesPeriodMap';
import type { Period } from '@utilities/timeSeriesPeriodMap';

export type QueryKeyType = [string, string, Period];

export const COMPANY_TIME_SERIES_QUERY_KEY = 'COMPANY_TIME_SERIES';

export const getQueryKey = ({
  canonicalUrl,
  period,
}: {
  canonicalUrl: string;
  period: Period;
}): QueryKeyType => [COMPANY_TIME_SERIES_QUERY_KEY, canonicalUrl, period];

const QUERY = gql(`
  query getCompanyTimeSeries(
    $canonicalUrl: String!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    Company(canonicalURL: $canonicalUrl) {
      name
      timeSeries(startDate: $startDate, endDate: $endDate, period: quarterly) {
        date
        businessRevenueSegmentsLtm
        geographicRevenueSegmentsLtm
        revenue
        retainedEarnings
        leveredFreeCashFlow
        depreciationAmortizationTotal
        changeNetWorkingCapital
        cogs
        grossProfit
        netIncome
        generalAdministrative
        salesMarketing
        rdExpense
        nonOperatingExpense
        stockBasedCompensation
      }
      data {
        currencyInfo
      }
    }
  }
`);

export const queryFn = async ({
  queryKey: [_, canonicalUrl, period],
}: QueryFunctionContext<QueryKeyType>) => {
  const { startDate, endDate } = getDateRangeByPeriod(period);

  const response = await gqlClient.request(QUERY, {
    canonicalUrl,
    startDate,
    endDate,
  });

  if ('Company' in response) {
    return response.Company;
  }
};
